import _ from "lodash";
import { randomstring } from "randomstring-js";
import {
  APP_API_KEY,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
} from "Constants";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  fileUploadRequest,
  uploadEncodedFile,
} from "NetworkCall";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export var FETCH_BRANDING = "fetch_branding";
export var SELECT_THEME_COLOR = "select_theme_color";
export var THEME_COLORS = "theme_colors";
export var UPDATE_EVENT_ICON_LOCALLY = "UPDATE_EVENT_ICON_LOCALLY";
export var UPDATE_EVENT_COVER_LOCALLY = "UPDATE_EVENT_COVER_LOCALLY";
export var UPDATE_WEB_ICON_LOCALLY = "UPDATE_WEB_ICON_LOCALLY";
export var UPDATE_WEB_COVER_LOCALLY = "UPDATE_WEB_COVER_LOCALLY";
export var SELECT_WEB_THEME_COLOR = "SELECT_WEB_THEME_COLOR";
export var WEB_THEME_COLORS = "WEB_THEME_COLORS";
export var SIDE_OR_BOTTOM_MENU_UPDATED = "SIDE_OR_BOTTOM_MENU_UPDATED";
export const EDIT_APP_BOTTOM_MENU = "EDIT_APP_BOTTOM_MENU";
export const CREATED_MENU = "CREATED_MENU";
export const SPLASH_SCREEN_DATA = "SPLASH_SCREEN_DATA";

export function fetchBrandingEmpty(session) {
  // This function is used to empty the branding redux data and later fetch the data by calling fetchBranding function
  return (dispatch) => {
    dispatch({ type: FETCH_BRANDING, payload: { resource: [] } });
  };
}

export function fetchBranding(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_BRANDING,
          payload: { resource: data.resource[0] },
        });
        var themecolors = [];
        var webthemecolors = [];

        var curthemecolor = data.resource[0].themecolor;
        themecolors.push({
          color: curthemecolor,
          custom: false,
          selected: true,
        });
        themecolors.push({ color: "", custom: true, selected: false });

        dispatch({ type: THEME_COLORS, payload: themecolors });
        dispatch({
          type: SELECT_THEME_COLOR,
          payload: {
            resource: { color: curthemecolor, custom: true, selected: true },
          },
        });

        var curtwebhemecolor = data.resource[0].webthemecolor;
        webthemecolors.push({
          color: curtwebhemecolor,
          custom: false,
          selected: true,
        });
        webthemecolors.push({ color: "", custom: true, selected: false });

        dispatch({ type: WEB_THEME_COLORS, payload: webthemecolors });
        dispatch({
          type: SELECT_WEB_THEME_COLOR,
          payload: {
            resource: { color: curtwebhemecolor, custom: true, selected: true },
          },
        });

        // Splash screen data
        var splashData = [
          {
            key: "iossplashscreen1",
            section: "ios",
            requiredSize: { width: 1242, height: 2208 },
            displaySize: { width: 201, height: 357 },
            cropperSize: { width: 195, height: 347 },
            data: data.resource[0].iossplashscreen1,
          },
          {
            key: "iossplashscreen2",
            section: "ios",
            requiredSize: { width: 1290, height: 2796 },
            displaySize: { width: 165, height: 357 },
            cropperSize: { width: 160, height: 347 },
            data: data.resource[0].iossplashscreen2,
          },
          {
            key: "androidsplashscreen1",
            section: "android",
            requiredSize: { width: 1242, height: 2208 },
            displaySize: { width: 253, height: 450 },
            cropperSize: { width: 248, height: 440 },
            data: data.resource[0].androidsplashscreen1,
          },
          {
            key: "androidsplashscreen2",
            section: "android",
            requiredSize: { width: 1290, height: 2796 },
            displaySize: { width: 208, height: 450 },
            cropperSize: { width: 203, height: 440 },
            data: data.resource[0].androidsplashscreen2,
          },
          {
            key: "androidsplashscreen3",
            section: "android",
            requiredSize: { width: 1080, height: 1920 },
            displaySize: { width: 214, height: 380 },
            cropperSize: { width: 208, height: 370 },
            data: data.resource[0].androidsplashscreen3,
          },
          {
            key: "androidsplashscreen4",
            section: "android",
            requiredSize: { width: 1080, height: 2400 },
            displaySize: { width: 203, height: 450 },
            cropperSize: { width: 198, height: 440 },
            data: data.resource[0].androidsplashscreen4,
          },
        ];

        dispatch(updateSplashData(splashData));
      },
      (error) => {}
    );
  };
}

export function uploadBrandingData(session, data, callback) {
  // debugger;
  var source = data.source ? data.source : "";
  var eventicon = data.eventicon;
  var eventcover = data.eventcover;
  var themecolor = data.themecolor;
  var updateAppSideMenu = false;
  var updateAppBottomMenu = false;

  if (
    data.hasOwnProperty("webthemecolor") ||
    data.hasOwnProperty("webcover") ||
    data.hasOwnProperty("webicon")
  ) {
    eventicon = data.webicon;
    eventcover = data.webcover;
    themecolor = data.webthemecolor;
  }

  if (themecolor === "" || themecolor === undefined) {
    themecolor = "#4da1ff"; //Use default theme color
  }

  if (
    data.hasOwnProperty("updatedmenu") ||
    data.hasOwnProperty("bottommenu") ||
    data.hasOwnProperty("sidemenu")
  ) {
    updateAppSideMenu = data.updatedmenu.sidemenu;
    updateAppBottomMenu = data.updatedmenu.bottommenu;
  }

  return (dispatch) => {
    if (eventicon && eventcover) {
      uploadEventIcon(session, eventicon, dispatch, (dataicon) => {
        uploadEventCover(session, eventcover, dispatch, (datacover) => {
          // debugger;
          var resourcedata = {
            themecolor: themecolor,
            navigationcolor: themecolor,
            menulogo: dataicon.name,
            eventicon: dataicon.name,
            eventcover: datacover.name,
          };
          if (
            data.hasOwnProperty("webthemecolor") ||
            data.hasOwnProperty("webcover") ||
            data.hasOwnProperty("webicon")
          ) {
            resourcedata = {
              webthemecolor: themecolor,
              webnavigationcolor: themecolor,
              webicon: dataicon.name,
              webcover: datacover.name,
            };
          }
          updateBranding(session, resourcedata, dispatch, callback);
        });
      });
    } else if (eventicon) {
      uploadEventIcon(session, eventicon, dispatch, (dataicon) => {
        // debugger;
        var resourcedata = {
          themecolor: themecolor,
          navigationcolor: themecolor,
          eventicon: dataicon.name,
          menulogo: dataicon.name,
        };
        if (
          data.hasOwnProperty("webthemecolor") ||
          data.hasOwnProperty("webcover") ||
          data.hasOwnProperty("webicon")
        ) {
          resourcedata = {
            webthemecolor: themecolor,
            webnavigationcolor: themecolor,
            webicon: dataicon.name,
          };
        }
        updateBranding(session, resourcedata, dispatch, callback);
      });
    } else if (eventcover) {
      uploadEventCover(session, eventcover, dispatch, (datacover) => {
        // debugger;
        var resourcedata = {
          themecolor: themecolor,
          navigationcolor: themecolor,
          eventcover: datacover.name,
        };
        if (
          data.hasOwnProperty("webthemecolor") ||
          data.hasOwnProperty("webcover") ||
          data.hasOwnProperty("webicon")
        ) {
          resourcedata = {
            webthemecolor: themecolor,
            webnavigationcolor: themecolor,
            webcover: datacover.name,
          };
        }
        updateBranding(session, resourcedata, dispatch, callback);
      });
    } else if (updateAppSideMenu || updateAppBottomMenu) {
      var resourcedata_BottomMenu = data;
      updateAppSideBottomMenu(
        session,
        resourcedata_BottomMenu,
        dispatch,
        callback
      );
    } else if (source === "splash") {
      var splashImages = data.splashdataarray;

      _uploadImages(session, splashImages, dispatch, (items) => {
        // console.log("response items :- ", items);
        var resourcedata = {};
        _.map(items, (o) => {
          resourcedata[o.key] = o.data;
        });

        updateBranding(session, resourcedata, dispatch, callback);
      });
    } else {
      // debugger;
      var resourcedata = {
        themecolor: themecolor,
        navigationcolor: themecolor,
      };
      if (
        data.hasOwnProperty("webthemecolor") ||
        data.hasOwnProperty("webcover") ||
        data.hasOwnProperty("webicon")
      ) {
        resourcedata = {
          webthemecolor: themecolor,
          webnavigationcolor: themecolor,
        };
      }
      updateBranding(session, resourcedata, dispatch, callback);
    }
  };
}

export function updateBranding(session, data, dispatch, callback) {
  var resource = { resource: { ...data, eventid: session.eventid } };
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event`;

  patchRequest(
    url,
    resource,
    session,
    dispatch,
    (responsedata) => {
      dispatch(hideLoading());
      callback({ success: 1 });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadImages(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;

  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.data ? item.data : "";

        var n = file.search(";base64,");

        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileType = "jpg";
          var filename = `eventify/${eventid}/branding/splash_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].data = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].data = null;
          resolve();
        } else {
          uploadFiles[index].data = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback([...uploadFiles]);
  });
}

export function uploadEventIcon(session, eventicon, dispatch, callback) {
  // debugger;
  var eventid = session.eventid;
  eventicon = eventicon.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/branding/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: eventicon,
      },
    ],
  };
  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback(data);
    },
    (error) => {
      callback({ error: 2, data: error });
    }
  );
}

export function uploadEventCover(session, eventcover, dispatch, callback) {
  // debugger;
  var eventid = session.eventid;
  eventcover = eventcover.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/branding/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: eventcover,
      },
    ],
  };

  //return (dispatch)=>{
  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback(data);
    },
    (error) => {
      callback({ error: 2, data: error });
    }
  );
  //}
}

export function updateSplashData(data) {
  return (dispatch) => {
    dispatch({ type: SPLASH_SCREEN_DATA, payload: data });
  };
}

export function updateEventIconLocally(image) {
  return (dispatch) => {
    dispatch({ type: UPDATE_EVENT_ICON_LOCALLY, payload: image });
  };
}

export function updateEventCoverLocally(image) {
  return (dispatch) => {
    dispatch({ type: UPDATE_EVENT_COVER_LOCALLY, payload: image });
  };
}

export function updateWebIconLocally(image) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WEB_ICON_LOCALLY, payload: image });
  };
}

export function updateWebCoverLocally(image) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WEB_COVER_LOCALLY, payload: image });
  };
}

export function updateMenuStyle(session, brandingData, index, callback) {
  var exhibitorview = 1;
  if (index === "tab-bar") {
    exhibitorview = 0;
  }
  if (brandingData === undefined) {
    brandingData = { ...brandingData, exhibitorview };
  } else {
    brandingData.exhibitorview = exhibitorview;
    brandingData = { ...brandingData };
  }
  return (dispatch) => {
    dispatch({ type: FETCH_BRANDING, payload: { resource: brandingData } });
  };
}

export function selectSwatch(color) {
  return (dispatch) => {
    dispatch({ type: SELECT_THEME_COLOR, payload: { resource: { color } } });
  };
}

export function updateThemeColors(colors) {
  return (dispatch) => {
    dispatch({ type: THEME_COLORS, payload: colors });
  };
}

export function selectWebSwatch(color) {
  return (dispatch) => {
    dispatch({
      type: SELECT_WEB_THEME_COLOR,
      payload: { resource: { color } },
    });
  };
}

export function updateWebThemeColors(colors) {
  return (dispatch) => {
    dispatch({ type: WEB_THEME_COLORS, payload: colors });
  };
}

export function updateAppSideBottomMenu(session, data, dispatch, callback) {
  var updateAppSideMenu = data.updatedmenu.sidemenu;
  var updateAppBottomMenu = data.updatedmenu.bottommenu;
  var sideMenu = data.sidemenu;
  var bottomMenu =
    data.bottommenu && data.bottommenu.length == 5 ? data.bottommenu : [];
  var body = [];

  if (updateAppSideMenu == true) {
    _.map(sideMenu, (obj) => {
      var value = {
        apptabid: obj.apptabid,
        taborder: obj.taborder,
        isenabled: obj.isenabled,
        eventid: session.eventid,
      };
      body.push(value);
    });
  }
  if (updateAppBottomMenu == true && bottomMenu.length > 0) {
    _.map(bottomMenu, (obj) => {
      var value = {
        apptabid: obj.apptabid,
        taborder: obj.taborder,
        isenabled: obj.isenabled,
        tabslected: obj.tabslected,
        displaytabname: obj.displaytabname,
        eventid: session.eventid,
      };
      body.push(value);
    });
  }

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/apptabs`;
  let resource = { resource: body };

  patchRequest(
    url,
    resource,
    session,
    dispatch,
    (responsedata) => {
      dispatch(hideLoading());
      callback({ success: 1 });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function updatedSideOrBottmeAppMenu(obj) {
  return (dispatch) => {
    dispatch({ type: SIDE_OR_BOTTOM_MENU_UPDATED, payload: obj });
  };
}

export function toggleEditAppBottomMenuEditor(obj) {
  return {
    type: EDIT_APP_BOTTOM_MENU,
    payload: obj,
  };
}

export function createdMenuSave(payload) {
  return { type: CREATED_MENU, payload: payload };
}

export function updateAppBottomMenuDisplayName(
  session,
  id,
  resource,
  callback
) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/apptabs/${id}`;
  var body = { ...resource, eventid: session.eventid };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, result: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateEmailtemplateswiththemecolor(
  session,
  previousthemcolor,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        eventid: session.eventid,
        previousthemcolor: previousthemcolor,
        type: "updateThemecoloremail_templates",
      },
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
